import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import Button from '@toasttab/shared/src/components/atoms/Button/Button'
import { ExternalLinkProps } from './ExternalLink.d'

const internalHosts = [
  '',
  'toasttab.test',
  'inttoasttab.test',
  'toast.local',
  'mktg-toasttab-com.local',
  '104.236.26.20',
  'phrasingpro2.com',
  'www.toasttab.com',
  'careers.toasttab.com',
  'central.toasttab.com',
  'status.toasttab.com',
  'refer.toasttab.com',
  'pos.toasttab.com',
  'investors.toasttab.com',
  'localpartners.toasttab.com',
  's3.amazonaws.com',
  'd2w1ef2ao9g8r9.cloudfront.net',
  'partners.toasttab.com',
  'rallyforrestaurant.com',
  'share.vidyard.com',
  'toasttakeout.com',
  'rallyforestaurants.com',
  'rallyforrestaurant.com',
  'rallyforrestaurants.com',
  'rallyforrestaurants.org',
  'stratex.com',
  'toast.org',
  'toastgo.com',
  'toasttab.ca',
  'toastinc.com',
  'toast.inc',
  'buytoast.com',
  'toastforrestaurants.com',
  'toastforgood.org',
  'toastorderandpay.com',
  'toast-shop.com',
  '142.93.76.41',
  'xtrachef.com',
  'toasttab.local',
  'phrasingpro3.com',
  'staging.phrasingpro3.com',
  'staging-noncf.phrasingpro3.com',
  'prod.phrasingpro3.com',
  'intl.phrasingpro3.com',
  'dev.phrasingpro3.com',
  'dev-noncf.phrasingpro3.com',
  'localhost',
  '192.241.134.173',
  'dwhoejhfdw8er.cloudfront.net',
  'di8blgq856e7l.cloudfront.net',
  'd10bf60mhsuiwk.cloudfront.net',
  'd1offsmk3b6j6h.cloudfront.net',
  'dev-craft-preview.phrasingpro3.com',
  'staging-craft-preview.phrasingpro3.com',
  'pos-craft-preview.phrasingpro3.com',
  'd2ibudjvyslmx1.cloudfront.net',
  'contentful-dev-proxy.phrasingpro3.com',
  'contentful-staging-proxy.phrasingpro3.com',
  'contentful-pos-proxy.phrasingpro3.com',
  'contentful-dev.phrasingpro3.com',
  'contentful-staging.phrasingpro3.com',
  'contentful-preview.phrasingpro3.com',
  'contentful-preview-dev.phrasingpro3.com',
  'contentful-preview-staging.phrasingpro3.com',
  'contentful-preview-master.phrasingpro3.com',
  'contentful-otl-preview-dev.phrasingpro3.com',
  'contentful-otl-preview-staging.phrasingpro3.com',
  'contentful-otl-preview-master.phrasingpro3.com',
  'contentful-pos.phrasingpro3.com',
  'dzlubb12xa1bc.cloudfront.net',
  'community.toasttab.com', // Playground Contentful Cloudfront Distribution
  'staging-support.phrasingpro3.com', // Staging Support
  'staging-support-preview.phrasingpro3.com', // Staging Preview
  'support.toasttab.com', // Production Support
  'apps.apple.com',
  'play.google.com',
  'toasttab.com',
  'support.phrasingpro3.com',
  'support.preview.phrasingpro3.com',
  'support.toasttab.com',
  'payroll.toasttab.com'
]
const excludedClasses = ['excluded-external-link-treatment']

const ExternalLink = ({
  content = 'You are leaving Toast’s website. Do you wish to continue?'
}: ExternalLinkProps) => {
  const [isExitModalEnabled, setExitModalEnabled] = useState(false)
  const [continueHref, setContinueHref] = useState(null)
  const [externalLinks, setExternalLinks] = useState([])

  const setExternalLink = (link: HTMLElement) => {
    const linkIsExcluded = Array.from(link.classList).some((className) =>
      excludedClasses.includes(className)
    )
      ? true
      : false

    if (linkIsExcluded) {
      link.addEventListener('click', (e) => handleLinkClick(e))
      return
    }

    const linkAlreadySet = link.querySelectorAll('.link--external__icon').length
      ? true
      : false
    if (linkAlreadySet) {
      return
    }

    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    icon.setAttributeNS(null, 'fill', 'none')
    icon.setAttributeNS(null, 'viewBox', '0 0 24 24')
    icon.style.display = 'inline-block'
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path.setAttributeNS(
      null,
      'stroke',
      window.getComputedStyle(link).getPropertyValue('color')
    )
    path.setAttributeNS(null, 'stroke-width', '1.5')
    path.setAttributeNS(null, 'stroke-miterlimit', '10')
    path.setAttributeNS(null, 'stroke-linecap', 'round')
    path.setAttributeNS(null, 'stroke-linejoin', 'round')
    path.setAttributeNS(
      null,
      'd',
      'M11.65 4.54999h-6.6c-1.1 0-2 .9-2 2V18.95c0 1.1.9 2 2 2h12.4c1.1 0 2-.9 2-2v-6.7m-3.6-9.20001h5.2m0 0v5.1m0-5.1L12.65 11.35'
    )
    icon.appendChild(path)
    icon.classList.add('icon', 'link--external__icon')
    const parent = link.parentNode
    const clonedLink: any = link.cloneNode(true)
    if (!link.classList.value.includes('hide-external-icon')) {
      clonedLink.appendChild(icon)
    }
    clonedLink.classList.add('link', 'link--external')
    clonedLink.addEventListener('click', (e: any) => handleLinkClick(e))
    parent.replaceChild(clonedLink, link)
    link.parentNode && link.parentNode.removeChild(link)
  }

  const handleLinkClick = (e: any) => {
    e.preventDefault()
    let target = e.target
    while (target && target.nodeName !== 'A') {
      target = target.parentNode
    }
    const href = target.getAttribute('href')
    const isSocialShare = target.getAttribute('data-social')
    !isSocialShare && openExitModal(href)
  }

  const openExitModal = (href: string) => {
    setExitModalEnabled(true)
    setContinueHref(href)
  }

  useEffect(() => {
    const allPageLinks = Array.from(document.querySelectorAll('a'))
    const externalLinks = allPageLinks.filter(
      (link: any) => !internalHosts.includes(link.hostname)
    )
    externalLinks.forEach((link: HTMLElement) => setExternalLink(link))
    setExternalLinks(externalLinks)
  }, [])

  const exitModalContainerCss = classNames(
    'exit-modal fixed top-0 left-0 z-[2000] h-screen w-screen bg-[rgba(0,0,0,0.75)] transition-all duration-300',
    {
      hidden: !isExitModalEnabled
    }
  )

  const handleCloseExitModal = () => {
    setExitModalEnabled(false)
  }

  return (
    <>
      {externalLinks && externalLinks.length > 0 && (
        <div className={exitModalContainerCss} data-testid='ExitModal'>
          <div className='bg-white rounded-md shadow-md left-1/2 fixed top-1/2 -translate-x-1/2 -translate-y-1/2 w-full p-10 max-w-xl max-h-52'>
            <p className='text-default text-lg'>{content}</p>
            <div className='flex justify-end items-center mt-4'>
              <Button
                variation='secondary-outline-otl'
                onClick={handleCloseExitModal}
              >
                Go Back
              </Button>
              <div className='w-2' />
              <Button
                variation='secondary-otl'
                href={continueHref}
                target='_blank'
                onClick={handleCloseExitModal}
              >
                Continue
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ExternalLink
